// extracted by mini-css-extract-plugin
module.exports = {"memo-title":"MemoPage_memo-title__3d-Fc"};